import React, { useEffect, useState } from 'react'
import UnauthorizedPage from '../../pages/Unauthorized/UnauthorizedPage'
import isUserAddonsValid from '../../utils/helpers/isUserAddonsValid'
import isUserOrgRolesValid from '../../utils/helpers/isUserOrgRolesValid'
import orgIsPayLocked from '../../utils/helpers/orgIsPayLocked'
import UNAUTHORIZED_REASONS from '../../utils/constants/unauthorizedReasons'
import isOrgAddonsValid from '../../utils/helpers/isOrgAddonsValid'
import hasPermission, { permissionsLoaded } from '../../utils/helpers/hasPermission'
import useGetLocalStorage from '../../hooks/useGetLocalStorage'
import localStorageIds from '../../utils/constants/localStorageIds'

// `requiredPermission`, when given, replaces the role check: the server's permissions from
// /users/me decide.
const withAuthHOC =
  (allowedOrgAddons, allowedAddons, allowedUserOrgRoles, payLocked, requiredPermission) =>
  (Component) =>
  (props) => {
    const [state, setState] = useState(null)
    const localStorageValue = useGetLocalStorage()
    const {
      [localStorageIds.SELECTED_ORG_SUB_STATUS]: selectedOrgSubscriptionStatus,
      [localStorageIds.SELECTED_ORG]: selectedOrg,
    } = localStorageValue || {}

    useEffect(() => {
      setState(selectedOrgSubscriptionStatus)
    },[selectedOrgSubscriptionStatus])

    if (!Component) return null

    // On login/org switch the org id lands in localStorage before the status query
    // returns; stay blank instead of flashing the paywall at every user.
    if (payLocked && selectedOrg && selectedOrgSubscriptionStatus == null) return null

    // Need to pass state down so it rerenders. Need to check exactly how it works.
    // The hook was supposed to do that, but not happening
    if (orgIsPayLocked(null, state) && payLocked) {
      return <UnauthorizedPage reason={UNAUTHORIZED_REASONS.SUBSCRIPTION} />
    }

    // Stay blank until /users/me has said what this user may do, instead of flashing Unauthorized.
    if (requiredPermission && !permissionsLoaded()) return null

    const roleOrPermissionAllows = requiredPermission
      ? hasPermission(requiredPermission)
      : isUserOrgRolesValid(allowedUserOrgRoles)

    if (
      (!isUserAddonsValid(allowedAddons) && !isOrgAddonsValid(allowedOrgAddons)) ||
      !roleOrPermissionAllows
    ) {
      return <UnauthorizedPage reason={UNAUTHORIZED_REASONS.ACCESS} />
    }

    return <Component {...props} />
  }

export default withAuthHOC
